export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-03_DE.4cc6b351.png";